import {
    createLibraryGoal,
    createLibraryTarget,
    deleteLibraryGoal,
    cloneLibraryGoal,
    createLibraryGoalTarget,
    editLibraryGoalTarget,
    deleteLibraryGoalTarget,
    reorderLibraryGoalTarget,
    changeLibraryGoalTargetMastery,
    changeLibraryGoalMastery,
    changeSingleLibraryGoalTargetMastery,
    removeSingleLibraryGoalTargetMastery,
    createLibraryGoalOption,
    editLibraryGoalOption,
    deleteLibraryGoalOption,
    reorderLibraryGoalOption,
    chooseTargetsFromLibraryGoal,
    chooseOptionsFromLibraryGoal,
    editLibraryGoal,
    editLibraryTarget,
    deleteLibraryTarget,
    getLibraryGoalById,
    getLibraryGoals,
    upsertLibrarySectionDescriptionBlock,
    deleteLibrarySectionDescriptionBlock,
    getLibraryFolders,
    createLibraryFolder,
    editLibraryFolder,
    deleteLibraryFolder,
    createLibraryOption,
    editLibraryOption,
    deleteLibraryOption,
    changeLibraryTargetMaintenance,
    addLibraryTargetMaintenanceStep,
    editLibraryTargetMaintenanceStep,
    deleteLibraryTargetMaintenanceStep,
    changeSingleLibraryTargetMaintenance,
    addSingleLibraryTargetMaintenanceStep,
    editSingleLibraryTargetMaintenanceStep,
    deleteSingleLibraryTargetMaintenanceStep,
    singleLibraryTargetFollowGoalConfig,
    singleLibraryTargetMasteryFollowGoal,
} from './library.action';
export { libraryReducer } from './library.reducer';
export { watchLibrary } from './library.saga';

export const libraryActions = {
    /** Goals */
    getLibraryGoals,
    getLibraryGoalById,
    createLibraryGoal,
    editLibraryGoal,
    deleteLibraryGoal,
    cloneLibraryGoal,
    upsertLibrarySectionDescriptionBlock,
    deleteLibrarySectionDescriptionBlock,

    createLibraryGoalTarget,
    editLibraryGoalTarget,
    deleteLibraryGoalTarget,
    reorderLibraryGoalTarget,
    createLibraryGoalOption,
    editLibraryGoalOption,
    deleteLibraryGoalOption,
    reorderLibraryGoalOption,

    chooseTargetsFromLibraryGoal,
    chooseOptionsFromLibraryGoal,
    /** End */

    /** Mastery Library */
    changeLibraryGoalTargetMastery,
    changeLibraryGoalMastery,
    changeSingleLibraryGoalTargetMastery,
    removeSingleLibraryGoalTargetMastery,
    /** End */

    /** Target Maintenance */
    changeLibraryTargetMaintenance,
    addLibraryTargetMaintenanceStep,
    editLibraryTargetMaintenanceStep,
    deleteLibraryTargetMaintenanceStep,
    /** End */

    /** Single Target Maintenance */
    changeSingleLibraryTargetMaintenance,
    addSingleLibraryTargetMaintenanceStep,
    editSingleLibraryTargetMaintenanceStep,
    deleteSingleLibraryTargetMaintenanceStep,
    singleLibraryTargetFollowGoalConfig,
    singleLibraryTargetMasteryFollowGoal,
    /** End */

    /** Clinical Library Folders */
    getLibraryFolders,
    createLibraryFolder,
    editLibraryFolder,
    deleteLibraryFolder,
    /** End */

    /** Targets */
    createLibraryTarget,
    editLibraryTarget,
    deleteLibraryTarget,
    /** End */

    /** Options */
    createLibraryOption,
    editLibraryOption,
    deleteLibraryOption,
    /** End */
};
